module.exports = __webpack_public_path__ + "static/media/vis16.34d8e12a.jpeg";